import styled from 'styled-components';

const StatusMark = styled.mark`
  display: flex;
  align-items: center;
  max-height: 20px;
  padding: 0 6px 1px 6px;
  border-radius: 4px;
  color: ${({ theme }) => theme.palette.secondary.contrastText};
  background-color: ${({ checked, theme }) => (checked ? theme.palette.secondary.main : theme.palette.blueGrey[600])};
  font-size: 0.75rem;
  font-weight: 500;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
`;

export default StatusMark;
